import type { PoolShippingStatus } from '../../../../modules/api';
import { ShipmentStepper } from './ShipmentStepper';
import { formatCarrier } from '../formatCarrier';

// Universal parcel-tracking service — works across carriers, so one URL
// covers whatever shipping company the operator used.
const PARCELS_TRACKING_URL = 'https://parcelsapp.com/en/tracking/';

export interface SuccessSectionProps {
  status?: PoolShippingStatus;
  trackingNumber?: string | null;
  companyName?: string | null;
}

/**
 * Top card on the Delivery Show page — tracking number (once the carrier
 * assigns one) plus the fulfilment progress. Matches Figma 361:132067.
 */
export function SuccessSection({
  status,
  trackingNumber,
  companyName,
}: SuccessSectionProps) {
  if (status === 'canceled') {
    return (
      <section>
        <span
          className="inline-flex items-center rounded-full px-2 py-[3px] text-[11px] font-semibold leading-none backdrop-blur-sm"
          style={{
            background: 'var(--co-ShippingItemStatus-canceledBg, rgba(255,255,255,0.16))',
            color: 'var(--co-ShippingItemStatus-canceledFg, rgba(255,255,255,0.78))',
          }}
        >
          Canceled
        </span>
      </section>
    );
  }

  return (
    <section className="flex flex-col gap-4">
      {trackingNumber && (
        <div>
          <h3
            className="text-[16px] font-bold leading-[22px] tracking-[-0.3px]"
            style={{ color: 'var(--co-MyPacksItemCard-titleColor, #FFFFFF)' }}
          >
            Tracking Number
          </h3>
          <p
            className="mt-2 text-[14px] font-semibold leading-[20px]"
            style={{ color: 'rgba(255,255,255,0.92)' }}
          >
            {companyName ? `${formatCarrier(companyName)} · ` : ''}
            <a
              href={`${PARCELS_TRACKING_URL}${encodeURIComponent(trackingNumber)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="underline underline-offset-2 hover:opacity-80"
            >
              {trackingNumber}
            </a>
          </p>
        </div>
      )}

      <ShipmentStepper status={status ?? 'pending'} />
    </section>
  );
}
